import { render, staticRenderFns } from "./addViolationNotice.vue?vue&type=template&id=b029d73e&scoped=true"
import script from "./addViolationNotice.vue?vue&type=script&lang=js"
export * from "./addViolationNotice.vue?vue&type=script&lang=js"
import style0 from "./addViolationNotice.vue?vue&type=style&index=0&id=b029d73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b029d73e",
  null
  
)

export default component.exports